export const isInternalDomain = (href: string): boolean => {
  return href.startsWith('https://www.coursera.org');
};
